export const EVENT_STATUS_CONSTANTS = Object.freeze({
  CREATED: "CREATED",
  DRAFT: "DRAFT",
  READY: "READY",
  PENDING: "PENDING",
  ONGOING: "ONGOING",
  EXPIRED: "EXPIRED",
  DELETED: "DELETED",
});
